import { createSelector } from "@reduxjs/toolkit";

import { IEventGuest } from "Bands/types";
import { mapKeys, reduce } from "lodash-es";
import { API_ENDPOINTS } from "shared/constants";
import { IDataKeys, IJSONAPIItem } from "shared/types";
import { buildSingleItem } from "shared/utils";
import { dataSelector, buildData } from "../helpers";

export const guestlistGuestsSelector = createSelector(dataSelector, data => {
  return buildData(data as any, IDataKeys.eventGuestListBlockEntry) as IEventGuest[];
});

export const guestlistGuestsSelectorCreator = (guestPaths?: string[]) =>
  createSelector(guestlistGuestsSelector, guests => mapIdsToGuests(guestPaths, guests));

const mapIdsToGuests = (guestPaths: string[] = [], guests: IEventGuest[]) => {
  const guestsMap = mapKeys(guests, ({ id }) => API_ENDPOINTS.EVENT_GUEST(id));

  return reduce(
    guestPaths,
    (selectedGuests: IEventGuest[], path) => {
      const selectedGuest = guestsMap?.[path];

      if (selectedGuest) {
        return [...selectedGuests, selectedGuest];
      }

      return selectedGuests;
    },
    []
  );
};

export const lastGuestlistSent = (id?: string) =>
  createSelector(dataSelector, (data: any) => {
    if (data[IDataKeys.lastGuestlistSent] && id && data[IDataKeys.lastGuestlistSent][id]) {
      const detailsExport = data[IDataKeys.lastGuestlistSent][id] as IJSONAPIItem;

      return buildSingleItem(detailsExport);
    }

    return null;
  });
